/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetSCCorrespondencesByOrganizationID = require('../services/GetSCCorrespondencesByOrganizationID');

var SecCorrespondenceView = require('../../common/views/SecCorrespondenceView');

module.exports = {
  channel: 'sc',

  event: 'build:organization-correspondence-grid-view',

  builder: function(organizationId) {
    return new PlaceholderView({
      viewPromise: buildOrganizationCorrespondenceView(organizationId)
    });
  }
};

function buildOrganizationCorrespondenceView(organizationId) {
  var deferred = $.Deferred();

  GetSCCorrespondencesByOrganizationID(organizationId)
    .done(function(correspondences) {
      deferred.resolve(
        new SecCorrespondenceView({
          mode: 'org',
          model: new Backbone.Model({
            organizationId: organizationId,
            correspondences: correspondences
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
